/*!
  * Furillo ajax-partials.js v2.0.0
  * Copyright 2023 Furillo Agency AB (https://www.furillo.se/)  
  */
import ajaxLoader from './ajax-loader.js';
export default class AjaxPartials {
    
    static makeRequest(container, callback) {
        const base = this;
        const url = container.getAttribute('data-ajax-url');

        if (url && url.length > 0) {
            ajaxLoader.addLoader(container);

            fetch(url).then(function (response) {
                return response.text();
            }).then(function (html) {
                ajaxLoader.removeLoader(container);
                container.innerHTML = html;
                
                if (callback && typeof callback === 'function') {
                    callback();
                }

            }).catch(function (err) {
                console.warn('Something went wrong.', err);
                ajaxLoader.removeLoader(container);
            });
        }
    }

    static init(element) {
        element.querySelectorAll('div[data-ajax-url],nav[data-ajax-url],ul[data-ajax-url]').forEach(container => {
            const autoLoad = container.getAttribute('data-ajax-autoload');
            if (!autoLoad || autoLoad === 'true') {
                this.makeRequest(container);
            }
        });
    }
}




//export default function (element) {

//    const toggleLoader = function(container) {

//        let loader = container.querySelector('span.loader');
        
//        if (loader) {
//            container.remove();
//            return;
//        }

//        loader = document.createElement('span');
//        loader.classList.add('loader');

//        container.appendChild(loader);
//    }

//    var makeRequest = function (container) {
//        const url = container.getAttribute('data-ajax-url');
//        if (url && url.length > 0) {
//            toggleLoader(container);

//            fetch(url).then(function (response) {
//                return response.text();
//            }).then(function (html) {
//                container.innerHTML = html;
//            }).catch(function (err) {
//                console.warn('Something went wrong.', err);
//                toggleLoader(container);
//            });
//        }
//    };

//    element.querySelectorAll('div[data-ajax-url]').forEach(container => {
//        const autoLoad = container.getAttribute('data-ajax-autoload');
//        if (!autoLoad || autoLoad === 'true') {
//            makeRequest(container);
//        }
//    });
//}